import { useTranslation } from "react-i18next";
import { useState } from "react";
import SortedHeader from "../../../components/Tables/SortedHeader";

export default function TechAreaList({
  list,
  setCreateOrEdit,
  setForDelete,
  searchObject,
  setSearchObject
}) {
  let { t } = useTranslation();

  const [headers, setHeaders] = useState([
    { label: t("Tech Area Name"), field: "Description" },
    { label: "" }
  ]);

  return (
    <div className="table-wrap quiz-management">
      <table>
        <thead>
          <SortedHeader
            searchObject={searchObject}
            setSearchObject={setSearchObject}
            headers={headers}
            setHeaders={setHeaders}
          />
        </thead>
        <tbody>
          {list.map((techArea) => (
            <tr>
              <td className="skill-name text-truncate">
                {t(techArea.description)}
              </td>

              <td className="actions">
                <button
                  onClick={() => setCreateOrEdit(techArea.id)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>

                <button
                  onClick={() => setForDelete(techArea)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
